// extracted by mini-css-extract-plugin
export default {"promoWrap":"jPIIJCvvwg6PD59d2z2O","promo":"Wrhou0A6DXprmduw7uUr","promoText":"dp4gjSxoO9Pf3gV9XMoh"};